import { offerRequestEstimatedVolumeSchema } from '../offer-request-management/projectSize.js';
// The minimum project volume a partner accepts.
export const partnerMinimumEstimatedVolumeSchema = offerRequestEstimatedVolumeSchema.exclude(['InformationOnly']);
export const PartnerMinimumEstimatedVolume = partnerMinimumEstimatedVolumeSchema.enum;
